<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>电子签列表</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-form
          :inline="false"
          :model="searchForm"
          ref="searchForRef" label-width="80px"
          autocomplete="on">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item size="small" label="合同标题" label-width="90px">
              <el-input v-model="searchForm.queryParams" placeholder="请输入合同标题" clearable type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同起期开始" size="small" label-width="100px">
              <el-date-picker v-model="searchForm.start_time" type="date"  placeholder="请选择开始时间" style="width: 90%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同起期结束" size="small" label-width="100px">
              <el-date-picker v-model="searchForm.end_time" type="date"  placeholder="请选择开始时间" style="width: 90%"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="状态" size="small" label-width="50px">
              <el-select
                  v-model="searchForm.status"
                  placeholder="请选择状态">
                <el-option label="签署中" :value="1"></el-option>
                <el-option label="已完成" :value="2"></el-option>
                <el-option label="撤销" :value="3"></el-option>
                <el-option label="过期" :value="5"></el-option>
                <el-option label="拒签" :value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
          </el-col>

        </el-row>
      </el-form>

      <!-- 表格 -->
<!--      <e-table :tableHeadConfig="tableHeadConfig" :tableLoadData="tableLoadData" >-->
<!--        <template v-slot:signFlowStartTime="slotData">-->
<!--          <span v-if="slotData.data.row.signFlowStartTime">{{slotData.data.row.signFlowStartTime | dateFormat}}</span>-->
<!--          <span v-else>未签署完成</span>-->
<!--        </template>-->
<!--        <template v-slot:signFlowEndTime="slotData">-->
<!--          <span v-if="slotData.data.row.signFlowEndTime">{{slotData.data.row.signFlowEndTime | dateFormat}}</span>-->
<!--          <span v-else>未签署完成</span>-->
<!--        </template>-->

<!--        <template v-slot:status="slotData">-->
<!--          <span>{{slotData.data.row.signFlowStatus | statusFilter}}</span>-->
<!--        </template>-->
<!--        <template v-slot:operation="slotData">-->
<!--          <el-button type="primary" size="mini" v-if="slotData.data.row.signFlowStatus!=2" @click="handelDetail(slotData)">签署合同</el-button>&lt;!&ndash;签署合同链接&ndash;&gt;-->
<!--          <el-button type="success" v-if="slotData.data.row.signFlowStatus==2"  size="mini"   @click="handelShow(slotData)">下载合同</el-button>&lt;!&ndash;下载合同&ndash;&gt;-->
<!--        </template>-->
<!--      </e-table>-->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="mini"
          :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          height="450"
      >
        <el-table-column
            label="ID"
            prop="id"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="合同标题"
            prop="signFlowTitle"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="签署流程ID"
            prop="signFlowId"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="运输公司名称"
            prop="shop_name"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="经办人名称"
            prop="op_name"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="合同开始时间"
            prop="signFlowStartTime"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">

            <span v-if="scope.row.signFlowStartTime">{{scope.row.signFlowStartTime | dateFormat}}</span>
            <span v-else>未签署完成</span>
          </template>
        </el-table-column>
        <el-table-column
            label="合同结束时间"
            prop="signFlowEndTime"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span v-if="scope.row.signFlowEndTime">{{scope.row.signFlowStartTime | dateFormat}}</span>
            <span v-else>未签署完成</span>
          </template>
        </el-table-column>
        <el-table-column
            label="合同状态"
            prop="status"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span>{{scope.row.signFlowStatus | statusFilter}}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="操作"

            width="130">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" v-if="scope.row.signFlowStatus!=2" @click="handelDetail(scope.row)">签署合同</el-button><!--签署合同链接-->
            <el-button type="success" v-if="scope.row.signFlowStatus==2"  size="mini"   @click="handelShow(scope.row)">下载合同</el-button><!--下载合同-->
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30,50, 100]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!--flowDetail-->
    <el-dialog :visible.sync="dialogFormVisible">
      <!--合同列表-->
      <el-table :data="downInfo.files"> <!--下载列表-->
        <el-table-column prop="fileId" label="合同id">
        </el-table-column>
        <el-table-column prop="fileName" label="合同名">
        </el-table-column>
        <el-table-column  label="下载">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="handelDown(scope.row)">下载合同</el-button><!--下载合同-->
          </template>
        </el-table-column>
      </el-table>
      <!--附件列表-->
      <div class="att"> 附件列表 </div>

      <el-table :data="downInfo.attachments" v-if="downInfo.attachments"  cell-style="margin-top: 30px">
        <el-table-column prop="fileId" label="合同id">
        </el-table-column>
        <el-table-column prop="fileName" label="合同名">
        </el-table-column>
        <el-table-column  label="下载">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="handelDown(scope.row)">下载合同</el-button><!--下载合同-->
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="downInfo.attachments" v-else> 附件列表暂无</el-table>
    </el-dialog>

    <el-dialog :visible.sync="fileOrder" width="100%" ref="tk">
      <template>
        <iframe :src="fileUrl" class="tableClass" width="100%" height="100%"></iframe>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment'     //日期时间转换

export default {
  name: "policyList",
  components: {
    eTable
  },
  props: {},
  data() {
    return {
      // 搜索
      searchForm: {
        queryParams: '',
        status:'',
        start_time:'',
        end_time:''
      },
      searchRules: {
        queryParams: [
          { required: true, message: "请输入合同标题", trigger: "blur" },
        ],
      },
      fileUrl:'',
      // 表头
      tableHeadConfig: [
        {
          label: "合同标题",
          field: "signFlowTitle",
          width: "350px"
        },
        {
          label: "签署流程ID",
          field: "signFlowId"
        },
        {
          label: "运输公司名称",
          field: "shop_name"
        },
        {
          label: "经办人名称",
          field: "op_name"
        },
        {
          label: "合同开始时间",
          columnType: "slot",
          slotName: "signFlowStartTime" //开始时间
        },
        {
          label: "合同结束时间",
          columnType: "slot",
          slotName: "signFlowEndTime"  //结束时间
        },
        {
          label: "合同状态",
          columnType: "slot",
          slotName: "status" //rescissionStatus
        },
        {
          label: "操作",
          columnType: "slot",
          slotName: "operation",
          width: 200
        }
        /*
        {
          label: "参与人",
          field: "signers"
        }*/
      ],
      // 数据
      tableLoadData: [],
      page:1,// 当前页码
      limit:10,// 每页大小
      total:0,//总条目数
      signFlowId: '',
      dialogFormVisible: false,
      fileOrder:false,
      title: '',
      visibleLine: 'none',
      flowDetail:{},
      downInfo:{}

    };
  },
  created() {
    this.DataList()

  },
  mounted() {},
  filters: {
    statusFilter(status) {
      // 0 - 草稿 1 - 签署中 2 - 完成 3 - 撤销 5 - 过期（签署截至日期到期后触发） 7 - 拒签
      ``
      if (status == 0) {
        return "草稿";
      } else if (status == 1) {
        return "签署中";
      }else if (status == 2) {
        return "完成";
      } else if (status == 3) {
        return "撤销";
      }else if (status == 5) {
        return "过期";
      }else if (status == 7) {
        return "拒签";
      }
    },
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined || !add_time) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
  },
  methods: {
    getTime (time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page: this.page,
        pageSize: this.limit,
      }
      if(this.searchForm.queryParams) param.queryParams = this.searchForm.queryParams
      if(this.searchForm.status) param.signFlowStatus = this.searchForm.status
      if(this.searchForm.start_time) param.start_time = this.getTime(this.searchForm.start_time)
      if(this.searchForm.end_time) param.end_time = this.getTime(this.searchForm.end_time)
      this.$axios.getEsignFileFlowList(param).then(res=>{
        if(res.code == 200){
          ////console.log(res.data,333);
          this.tableLoadData = res.data.data
          this.total = res.data.total
          if(this.total==0){
            const resData = {
              "msg": "获取成功",
              "data": {
                "total": 16,
                "per_page": 10,
                "current_page": 2,
                "last_page": 2,
                "data": [
                  {
                    "id": 12,
                    "add_time": 1695698766,
                    "op_uid": 13,
                    "op_name": "智胜",
                    "docTemplateId": "b0618765d4044c8593b611f6ed722cf8",
                    "docTemplateName": "国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "fileId": "7a3b67ff6a37412cbf91050fdd26ad5f",
                    "fileDownloadUrl": "https://esignoss.esign.cn/1111564182/e3c15ec3-0932-4465-8fa6-66174ade98fb/%E5%9B%BD%E4%BB%BB%E5%85%AC%E8%B7%AF%E8%B4%A7%E8%BF%90%E5%AE%9A%E9%A2%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%A3%B0%E6%98%8E%EF%BC%88%E9%BB%84%E8%89%B2%E9%83%A8%E5%88%86%E5%8A%A1%E5%BF%85%E5%A1%AB%E5%86%99%E5%AE%8C%E6%95%B4%EF%BC%89%2810%29.pdf?Expires=1695702365&OSSAccessKeyId=LTAI4G23YViiKnxTC28ygQzF&Signature=%2FPT8XdSdLNQSXoXyHk6RZeVUe8o%3D",
                    "signFlowId": "28a18c18b15647ed96e76ff642cdbd9d",
                    "company_id": 1,
                    "signFlowTitle": "20230926112605临沂连成运输有限公司的委托合同-国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "order_id": "51B76B29-7DD3-E1A0-46EB-A3D3FE648FF1",
                    "shop_id": 816,
                    "shop_name": "",
                    "signFlowStartTime": 0,
                    "signFlowEndTime": 0,
                    "signFlowStatus": 1,
                    "rescissionStatus": 0
                  },
                  {
                    "id": 13,
                    "add_time": 1695700230,
                    "op_uid": 13,
                    "op_name": "智胜",
                    "docTemplateId": "b0618765d4044c8593b611f6ed722cf8",
                    "docTemplateName": "国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "fileId": "d62f3e04995744a5922bef91e8a0f61a",
                    "fileDownloadUrl": "https://esignoss.esign.cn/1111564182/5aa645bb-3c7c-4f15-bbd9-43a88f149172/%E5%9B%BD%E4%BB%BB%E5%85%AC%E8%B7%AF%E8%B4%A7%E8%BF%90%E5%AE%9A%E9%A2%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%A3%B0%E6%98%8E%EF%BC%88%E9%BB%84%E8%89%B2%E9%83%A8%E5%88%86%E5%8A%A1%E5%BF%85%E5%A1%AB%E5%86%99%E5%AE%8C%E6%95%B4%EF%BC%89%2810%29.pdf?Expires=1695703829&OSSAccessKeyId=LTAI4G23YViiKnxTC28ygQzF&Signature=APqgRxvsumj%2BUCTTcFX6kH%2FPieI%3D",
                    "signFlowId": "05f77ce6e9c54c8aada5edbcd450a2b1",
                    "company_id": 1,
                    "signFlowTitle": "20230926115029兰陵县华杰运输有限公司的委托合同-国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "order_id": "66E7836D-CF0F-8787-F6ED-83AAB4AF55C7",
                    "shop_id": 816,
                    "shop_name": "",
                    "signFlowStartTime": 0,
                    "signFlowEndTime": 0,
                    "signFlowStatus": 1,
                    "rescissionStatus": 0
                  },
                  {
                    "id": 14,
                    "add_time": 1695706368,
                    "op_uid": 13,
                    "op_name": "智胜",
                    "docTemplateId": "b0618765d4044c8593b611f6ed722cf8",
                    "docTemplateName": "国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "fileId": "4bf2760e9bc64ffaa4de2b358fd80bcf",
                    "fileDownloadUrl": "https://esignoss.esign.cn/1111564182/16583a88-24ef-4905-9705-5a5a4b01460a/%E5%9B%BD%E4%BB%BB%E5%85%AC%E8%B7%AF%E8%B4%A7%E8%BF%90%E5%AE%9A%E9%A2%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%A3%B0%E6%98%8E%EF%BC%88%E9%BB%84%E8%89%B2%E9%83%A8%E5%88%86%E5%8A%A1%E5%BF%85%E5%A1%AB%E5%86%99%E5%AE%8C%E6%95%B4%EF%BC%89%2810%29.pdf?Expires=1695709966&OSSAccessKeyId=LTAI4G23YViiKnxTC28ygQzF&Signature=tuo%2Bp7cjCTLuIujfEf45PkT0ViE%3D",
                    "signFlowId": "150193494a06498e94fa1bb811e13fa4",
                    "company_id": 1,
                    "signFlowTitle": "20230926133246兰陵县华杰运输有限公司的委托合同-国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "order_id": "E3B2F48C-D037-67FE-8A54-6998D956ECC9",
                    "shop_id": 816,
                    "shop_name": "",
                    "signFlowStartTime": 0,
                    "signFlowEndTime": 0,
                    "signFlowStatus": 1,
                    "rescissionStatus": 0
                  },
                  {
                    "id": 15,
                    "add_time": 1695708028,
                    "op_uid": 13,
                    "op_name": "智胜",
                    "docTemplateId": "b0618765d4044c8593b611f6ed722cf8",
                    "docTemplateName": "国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "fileId": "0051180b483e45d7928d696cc0195c87",
                    "fileDownloadUrl": "https://esignoss.esign.cn/1111564182/c598d4f4-3605-44d0-b84c-bab981ce1d6f/%E5%9B%BD%E4%BB%BB%E5%85%AC%E8%B7%AF%E8%B4%A7%E8%BF%90%E5%AE%9A%E9%A2%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%A3%B0%E6%98%8E%EF%BC%88%E9%BB%84%E8%89%B2%E9%83%A8%E5%88%86%E5%8A%A1%E5%BF%85%E5%A1%AB%E5%86%99%E5%AE%8C%E6%95%B4%EF%BC%89%2810%29.pdf?Expires=1695711627&OSSAccessKeyId=LTAI4G23YViiKnxTC28ygQzF&Signature=ri41qgXhAuMwKU4V2xG%2ByWQGHaI%3D",
                    "signFlowId": "aef248f24ef741ddb032231655c24737",
                    "company_id": 1,
                    "signFlowTitle": "20230926140027兰陵县华杰运输有限公司的委托合同-国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "order_id": "BFE216FA-383A-07E9-EDD7-43CEF4E3E5F3",
                    "shop_id": 1733,
                    "shop_name": "兰陵县华杰运输有限公司",
                    "signFlowStartTime": 1695708028,
                    "signFlowEndTime": 0,
                    "signFlowStatus": 1,
                    "rescissionStatus": 0
                  },
                  {
                    "id": 16,
                    "add_time": 1695709664,
                    "op_uid": 13,
                    "op_name": "智胜",
                    "docTemplateId": "b0618765d4044c8593b611f6ed722cf8",
                    "docTemplateName": "国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "fileId": "8982a97944614465b926d4a692267863",
                    "fileDownloadUrl": "https://esignoss.esign.cn/1111564182/fda5781f-bcc9-4349-a4be-8755a5ade341/%E5%9B%BD%E4%BB%BB%E5%85%AC%E8%B7%AF%E8%B4%A7%E8%BF%90%E5%AE%9A%E9%A2%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%A3%B0%E6%98%8E%EF%BC%88%E9%BB%84%E8%89%B2%E9%83%A8%E5%88%86%E5%8A%A1%E5%BF%85%E5%A1%AB%E5%86%99%E5%AE%8C%E6%95%B4%EF%BC%89%2810%29.pdf?Expires=1695713263&OSSAccessKeyId=LTAI4G23YViiKnxTC28ygQzF&Signature=VBFL71tnqGYEiKxbUyBr4fOPZf0%3D",
                    "signFlowId": "918e03db6a0f4847af0e33dbf963d802",
                    "company_id": 1,
                    "signFlowTitle": "20230926142743临沂连成运输有限公司的委托合同-国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "order_id": "8B7BB1D7-0F23-6EFE-9BA1-E1B11EE65155",
                    "shop_id": 1726,
                    "shop_name": "临沂连成运输有限公司",
                    "signFlowStartTime": 1695709664,
                    "signFlowEndTime": 0,
                    "signFlowStatus": 1,
                    "rescissionStatus": 0
                  },
                  {
                    "id": 17,
                    "add_time": 1695709760,
                    "op_uid": 13,
                    "op_name": "智胜",
                    "docTemplateId": "b0618765d4044c8593b611f6ed722cf8",
                    "docTemplateName": "国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "fileId": "2f5a9460ac234283a6c503f6adad24ee",
                    "fileDownloadUrl": "https://esignoss.esign.cn/1111564182/4aab70a5-a9f0-4c0c-92ec-db8795498d84/%E5%9B%BD%E4%BB%BB%E5%85%AC%E8%B7%AF%E8%B4%A7%E8%BF%90%E5%AE%9A%E9%A2%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%A3%B0%E6%98%8E%EF%BC%88%E9%BB%84%E8%89%B2%E9%83%A8%E5%88%86%E5%8A%A1%E5%BF%85%E5%A1%AB%E5%86%99%E5%AE%8C%E6%95%B4%EF%BC%89%2810%29.pdf?Expires=1695713359&OSSAccessKeyId=LTAI4G23YViiKnxTC28ygQzF&Signature=fJxrjgvEPgDz%2BY5O3pi3zVCgsFQ%3D",
                    "signFlowId": "1c02a3be4ea64afdad70964be9797a14",
                    "company_id": 1,
                    "signFlowTitle": "20230926142919临沂连成运输有限公司的委托合同-国任公路货运定额险投保声明（黄色部分务必填写完整）(10)",
                    "order_id": "AC7DF938-9145-5C07-AAF0-D03B256C9973",
                    "shop_id": 1726,
                    "shop_name": "临沂连成运输有限公司",
                    "signFlowStartTime": 1695709760,
                    "signFlowEndTime": 0,
                    "signFlowStatus": 1,
                    "rescissionStatus": 0
                  }
                ]
              },
              "code": 200
            };
            this.tableLoadData = resData.data.data
            this.total = resData.data.total
          }
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.limit = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.page = newPage
      this.DataList()
    },

    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        role_name: '',
      }
      this.dialogFormVisible = true
    },
    handelDetail(index) {
      this.signFlowId = index.signFlowId
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        signFlowId: this.signFlowId,
      }
      this.$axios.getFileSignUrl(param).then(res=>{
        if(res.code == 200){
          this.$refs.tk.$el.firstChild.style.height = '100%';
          this.fileOrder = true;
          this.fileUrl = res.data.url;
          //window.open(res.data.url)
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },

    searchSubmit() {
      this.$refs.searchForRef.validate((valid) => {
        if (valid) {
          this.page = 1,
              this.DataList()
        }
      })
    },
    handelShow(e){
      this.dialogFormVisible = true
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        signFlowId: e.signFlowId,
      }
      this.$axios.downloadFileUrl(param).then(res=>{
        if(res.code == 200){
          this.downInfo = res.data
          //下载
          //window.open(res.data.downloadUrl)
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    handelDown(e) {
      ////console.log(e)
      window.open(e.downloadUrl)
    },
  },
};
</script>
<style>
.table_name{
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
/deep/.att{
  margin-top: 30px;
  padding: 30px;
}
.el-dialog__body{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/insurance/signDocList.vue